module.exports = __webpack_public_path__ + "7151d73e096ba45b8fe042b36b2560bb.ico";